import React from "react";
import { injectIntl } from "react-intl";
import messagesData from "../lang/preferences"; // or correct path

class EditableFormattedMessageBase extends React.Component {
  constructor(props) {
    super(props);
    const { msgKey, intl } = props;
    
    const msg = messagesData[msgKey];
  
    const resolvedId = msg && msg.id ? msg.id : msgKey;
    let message = "";
    try {
      message = intl.formatMessage({ id: resolvedId });
    } catch (e) {
      message = msgKey;
    }
    this.state = {
      editing: false,
      value: message,
      dirty: false,
      original: message,
      showReloadModal: false,
      locallyEdited: false,
    };
    this.spanRef = React.createRef();
  }

  handleClick = () => {
    const { msgKey, intl } = this.props;
    const msg = messagesData[msgKey];
    const resolvedId = msg && msg.id ? msg.id : msgKey;
    let message = "";
    try {
      message = intl.formatMessage({ id: resolvedId });
    } catch (e) {
      message = msgKey;
    }
    this.setState({
      editing: true,
      original: message,
      value: message,
      dirty: false,
    });
  };

  handleReload = () => {
    console.log("Reloading page after update");
    window.location.reload();
  };

  handleInput = () => {
    if (this.spanRef.current) {
      const newValue = this.spanRef.current.innerText;
      this.setState({
        value: newValue,
        dirty: newValue !== this.state.original,
      });
    }
  };

  handleConfirm = async (event) => {
     if (event) event.preventDefault();
    if (this.spanRef.current) {
      const newValue = this.spanRef.current.innerText;
      const { msgKey, intl, updateMessage } = this.props;
      const msg = messagesData[msgKey];
      const resolvedId = msg && msg.id ? msg.id : msgKey;
      const oldValue = this.state.original;

      const code = window.sessionStorage.getItem("code");
      const updateUrl = "/update-translation.php?t=" + Date.now();

      if (updateMessage) {
        updateMessage(msgKey, newValue);
        console.log("Update message called", msgKey, newValue);
      }

      this.setState({
        editing: false,
        value: newValue,
        dirty: false,
        original: newValue,
        locallyEdited: true,
      });
      setTimeout(async () => {
        try {
          const response = await fetch(updateUrl, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              lang: intl.locale,
              key: resolvedId,
              value: newValue,
              code: Number(code),
            }),
          });
          if (response.ok) {
              // Update messagesData[msgKey] with the new value
              if (messagesData[msgKey]) {
                messagesData[msgKey].defaultMessage = newValue;
              } else {
                messagesData[msgKey] = { id: msgKey, defaultMessage: newValue };
              }
              console.log("Edit updated successfully", "set state", window.location.pathname);
              if (this.props.reloadTranslations && !window.location.pathname.includes('/test-review')) {
                this.props.reloadTranslations(intl.locale);
              }
              if (!window.location.pathname.includes('/test-review')) {
                this.setState({ showReloadModal: true });
              }
            }
          if (!response.ok) {
            if (updateMessage) {
              updateMessage(msgKey, oldValue);
            }
            this.setState({
              value: oldValue,
              original: oldValue,
              locallyEdited: false,
            });
          }
        } catch (e) {
          if (updateMessage) {
            updateMessage(msgKey, oldValue);
          }
          this.setState({
            value: oldValue,
            original: oldValue,
            locallyEdited: false,
          });
        }
      }, 0);
    }
  };

  handleCancel = () => {
    if (this.spanRef.current) {
      this.spanRef.current.innerText = this.state.original;
    }
    this.setState({
      editing: false,
      value: this.state.original,
      dirty: false,
    });
  };

  componentDidUpdate(prevProps, prevState) {
  const { msgKey, intl, messages, locale } = this.props;
  // Focus and select all when entering editing mode
  if (this.state.editing && !prevState.editing && this.spanRef.current) {
    this.spanRef.current.innerText = this.state.value;
    this.spanRef.current.focus();
    document.execCommand("selectAll", false, null);
    document.getSelection().collapseToEnd();
  }
  // Sync local value if parent messages or locale changed
  if (
    !this.state.editing &&
    (
      prevProps.msgKey !== msgKey ||
      prevProps.locale !== locale ||
      prevProps.messages !== messages ||
      prevProps.intl?.locale !== intl?.locale
    )
  ) {
    const msg = messagesData[msgKey];
    const resolvedId = msg && msg.id ? msg.id : msgKey;
    let message = "";
    try {
      message = intl.formatMessage({ id: resolvedId });
    } catch (e) {
      message = msgKey;
    }
    // Locale changed — clear any local edit and sync to the new locale's translation
    this.setState({ value: message, original: message, locallyEdited: false });
  }
}

  render() {
    const { msgKey, intl } = this.props;
    const { editing, dirty } = this.state;

    if (!msgKey || typeof msgKey !== "string" || !msgKey.trim()) {
      return <>{msgKey || ""}</>;
    }

    const msg = messagesData[msgKey];
    const resolvedId = msg && msg.id ? msg.id : msgKey;

    if (!resolvedId || typeof resolvedId !== "string" || !resolvedId.trim()) {
      return <>{msgKey || ""}</>;
    }

    let message = "";
    try {
      message = intl.formatMessage({ id: resolvedId });
    } catch (e) {
      message = msgKey;
    }

    const valid = !!resolvedId && !!message && message !== resolvedId;

    if (!valid) return <>{msgKey || ""}</>;

    if (editing) {
      return (
        <span className="efm-editing-wrapper">
          <span
            ref={this.spanRef}
            contentEditable
            suppressContentEditableWarning
            onInput={this.handleInput}
            className="efm-editing-span"
            spellCheck={true}
          />
          <button type="button" onClick={e => { e.preventDefault(); this.handleCancel();}} className="efm-cancel-btn">
            ✖
          </button>
          {dirty && (
            <button type="button" onClick={e => { e.preventDefault(); this.handleConfirm();}} className="efm-confirm-btn">
              ✔
            </button>
          )}
        </span>
      );
    }

    // Show locally-edited value immediately after a confirmed edit;
    // otherwise show live intl message so locale switches reflect instantly.
    return <span onClick={this.handleClick}>{this.state.locallyEdited ? this.state.value : message}</span>;
  }
}

export default injectIntl(EditableFormattedMessageBase);